import{post } from '@/utils/request';
import{overseasserver,erpserver} from '@/utils/baseUrl';

//列表查询
export async function list(params) {
    return post(erpserver+'/cost/coefficient/list', params, true)
}
// 获取领用部门
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true);
}
// 获取产品
export async function getScorderPzList(params) {
    return post(erpserver+'/scorder/getScorderPzList', params, true);
}
//保存
export async function save(params) {
    return post(erpserver+'/cost/coefficient/save', params, true)
}
//核算区域列表
export async function listRegion(params) {
    return post(erpserver+'/cost/coefficient/listRegion', params, true)
}
// 获取公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
